export default function ( variableList, variableName ) {
    
    if ( variableList && variableList.length > 0 && variableName ) {
        if ( Array.isArray( variableList ) ) {
            const companyVar = variableList.find( ( variable ) => variable.name ===  variableName );
            if ( companyVar ) {
                return companyVar.value;
            } else {
                return '';
            }
        } else {
            return undefined;
        }
    } else {
        return '';
    }
}